
class SearchBar_with_Model {
  constructor() {

    this.appUrl = "https://softheight.tech/public";
    this.timer_search;

    this.search_loader = `<div class="loader-container">
      <div class="loader"></div>
    </div>`;

    this.show_suggestions = false;
    this.show_products = false;

    this.elm_search = 4;
    this.elm_id = "#snize-ac-items-container-";
    
    this.__init();
    this.paginator_model();
  }

  __init(){

    let self = this;
    $(document).on("focus keyup", "#header-global-search-input", function () {
      let searchVal = $(this).val();

      if($(".snize-ac-results .snize-ac-results-content .loader-container").length){
        $(".snize-ac-results .snize-ac-results-content .loader-container").removeClass("d-none");
      }
    
      clearTimeout(self.timer_search);

      // self.has_model_search();
    
      if(searchVal){
        self.timer_search = setTimeout(() => {

          if ($(".snize-ac-results .snize-ac-results-content .loader-container").length === 0) {
            $(".snize-ac-results .snize-ac-results-content").append(self.search_loader);
          }
            var form = new FormData();
            form.append("model_no", searchVal);
      
            var settings = {
               url: self.appUrl+"/api/model_number_searcher",
               method: "POST",
               data: form,
               processData: false,
               contentType: false,
               dataType: "json",
            };
            
            $.ajax(settings).done(function (response) {
              // console.log(response, searchVal);

              if(!Object.keys(response).length > 0){
                $(".snize-ac-results .snize-ac-results-content .loader-container").addClass("d-none");
              }else{
                self.search_action(response, searchVal)
              }
              
            });
        }, 250)
      }
      
    })
  }

  search_action(data, userInput){
    
    let any_show = false;

    // for(let i = 1; i <= this.elm_search; i++){
    //   if ($(this.elm_id+this.elm_search).hasClass("snize-hidden")) {
    //     any_show = false;
    //   }else{
    //     any_show = true;
    //     break;
    //   }
    // }

    if (!any_show) {

      let similarSkus = this.filterModels(data, userInput);
      // console.log(similarSkus);
      let products = similarSkus.products;
      let models_no = similarSkus.model_no;
      
      this.suggestion__model_html(models_no);
      this.products_html(products);

      $(".snize-nothing-found.snize-removable").addClass("snize-hidden")
      $(".snize-ac-results .snize-ac-results-content .loader-container").addClass("d-none")
      
    }else{
      $(".snize-ac-results .snize-ac-results-content .loader-container").addClass("d-none")
    }

    
  }

  suggestion__model_html(models_no){
    let html = `<li class="snize-label">Popular suggestions</li>`;

    for(let i = 0; i < models_no.length; i++){
      if(i <= 6){
        html += `<li class="snize-suggestion snize-ac-odd" style="cursor: pointer;">${models_no[i]}</li>`;
      }else{
        html += `<li class="snize-suggestion snize-ac-odd d-none" style="cursor: pointer;">${models_no[i]}</li>`;
      }
    }

    if(models_no.length > 6){
      html += `<li class="show_more" style="cursor: pointer;"><a href="#">Show More</a></li>`
    }


    // $(`${this.elm_id}1`).removeClass("snize-hidden")
    $(`${this.elm_id}1`).addClass("snize-hidden")
    $(`${this.elm_id}1`).html(html);
    
  }

  products_html(products){
    let html = `<li class="snize-label">Products</li>`;

    for (let product in products) {
      let prduct = products[product];

      html += `<li class="snize-product snize-product-in-stock snize-ac-odd w-50" id="snize-ac-product-${prduct.id}" style="cursor: pointer;">
          <a href="/products/${prduct.handle}" class="snize-item" draggable="false">
              <div class="snize-thumbnail">
                <img src="${prduct.image.src}&width=150&height=150" alt="${prduct.title}" class="snize-item-image " />
              </div>
              <div class="snize-product-info">
                  <span class="snize-title">${prduct.title}</span>
                  <span class="snize-description" style="max-height: 2.8em; -webkit-line-clamp: 2;">
                    ${prduct.description}
                  </span>
                  <span class="snize-sku">${prduct.variants[0].sku}</span>
                  <div class="snize-ac-prices-container">
                      <div class="snize-price-list">
                          <span class="snize-price snize-price-with-discount money ">£${prduct.variants[0].price}</span>
                          <!-- <span class="snize-discounted-price money "></span> -->
                          <span class="snize-save-price-wrapper"></span>
                      </div>
                  </div>
                  <div class="snize-labels-wrapper"></div>
              </div>
          </a>
      </li>`
    }
    
    $(`${this.elm_id}4`).removeClass("snize-hidden")
    $(`${this.elm_id}4`).html(html);
    
  }

  filterModels(skusArray, userInput) {
    const lowerUserInput = userInput.toLowerCase();
    const userInputLength = lowerUserInput.length;
    let model_no = [];
    let filteredSkus = [];
  
    for (let skus in skusArray) {
      let models = skusArray[`${skus}`].models;
  
      let filteredSkus2 = [];
      let models2 = [];
      if (typeof models === 'object' && models !== null) {
        models2 = Object.keys(models).map(function(key) {
          return models[key];
        });
      } else {
        models2 = models;
      }
      let ids_uniquie = [];
      
      filteredSkus2 = models2.filter(sku => {
        const lowerSku = sku.toLowerCase();
        const truncatedSku = lowerSku.substring(0, userInputLength + 2);
        if (truncatedSku.includes(lowerUserInput)) {
          model_no.push(sku);
          let sku_products = skusArray[`${skus}`].products;
          for (let product in sku_products) {
            if(!ids_uniquie.includes(product)){
              filteredSkus.push(sku_products[product])
              ids_uniquie.push(product)
            }
          }
          // filteredSkus = skusArray[`${skus}`].products;
        }
        return truncatedSku.includes(lowerUserInput);
      });
    }
  
    return { products: filteredSkus, model_no };
  }

  paginator_model(){
    $(document).on("click", "li.show_more", function(event){
      event.preventDefault();
      $(".snize-suggestion.d-none").each(function(i, elm){
        if(i <= 6){
          $(this).removeClass("d-none");
        }
      })

      if($(".snize-suggestion.d-none").length == 0){
        $(this).text("Show less");
        $(this).addClass("show_less");
        $(this).removeClass("show_more");
      }
    })

    $(document).on("click", "li.show_less", function(event){
      event.preventDefault();
      $("li.snize-suggestion").each(function(i, elm){
        if(i > 6){
          $(this).addClass("d-none");
        }
      })

      if($(".snize-suggestion.d-none").length != 0){
        $(this).text("Show More");
        $(this).addClass("show_more");
        $(this).removeClass("show_less");
      }
    })
  }
  
}

new SearchBar_with_Model();